import { useRef, useState } from "react";
import { ErrorsDisplay } from "../Shared/Error";
import { API_RequestPasswordReset } from "../../../apis/ApisAuth";

export function PasswordRecoveryForm() {
    const [input, setInput] = useState<string>('');
    const [sent, setSent] = useState<boolean>(false);
    const [errors, setErrors] = useState<string[]>([]);
    const inputRef = useRef<HTMLInputElement>(null);

    const tryRequest = async () => {
        let errors: string[] = [];
        if (input != '' && input.length > 0) {
            inputRef?.current?.classList.add("is-valid");
            inputRef?.current?.classList.remove("is-invalid");
            await API_RequestPasswordReset(input);
            setSent(true);
        }
        else {
            errors = (["Please provide a username"]);

            inputRef?.current?.classList.remove("is-valid");
            inputRef?.current?.classList.add("is-invalid");
        }

        setErrors(errors);
    }

    return (
        <>
            <form className="flex-column" role="password-recovery">
                {sent ? <>
                    <p> Your password reset request has been processed,
                        if the username is associated with an account we will send you a password reset email,
                        please follow the instructions in the email.
                    </p>

                    <p>Please check your email including junk folders.</p>
                </> : <>
                    <p>Enter your email address and we will send you a password reset link.</p>
                    <ErrorsDisplay errors={errors} />
                    <div className="col-auto">
                        <label htmlFor="usernameontrol" className="form-label-alt">Username</label>
                        <input ref={inputRef} placeholder="Username" id="usernameontrol" className="form-control"
                            value={input}
                            required
                            type="text"
                            onChange={t => {
                                setInput(t.currentTarget.value);
                                inputRef?.current?.classList.remove("is-valid");
                                inputRef?.current?.classList.remove("is-invalid");
                            }} />
                        <div className="invalid-feedback">
                            Please provide a username
                        </div>
                    </div>
                    <div className="text-center">
                        <button className="btn btn-alt mt-3 btn-wider" type="submit" onClick={e => {
                            e.preventDefault();
                            tryRequest();
                        }}>Request</button>
                    </div>
                </>}
            </form>
        </>
    );
}